import { fullstoryEvent } from './fullstoryUtils'
import { hasImageRulesViolations, isImageRulesResultBlocked } from './imageRulesResult'

// Name and properties match perfectgift-consumer's event (src/common/utilities/fullstory/events.ts,
// sendAiImageCheckResultFSEvent), so one FullStory dashboard covers both sites; change both together.
export const AI_IMAGE_CHECK_RESULT = 'ai_image_check_result'

/**
 * Properties for one check decision, or null when no checker answered.
 * The outcome is what the customer was shown, so a legacy flag warns even when V2 passed.
 * The V2 result is only in the response in live mode; otherwise the checker is reported as legacy.
 */
export function aiImageCheckResultProperties(result, { source = 'upload', medium = null } = {}) {
    if (!result || typeof result !== 'object') {
        return null
    }

    const shared = {
        outcome: isImageRulesResultBlocked(result)
            ? 'blocked'
            : hasImageRulesViolations(result)
              ? 'warned'
              : 'allowed',
        source,
        medium,
        attempt_timestamp: new Date().toISOString(),
        ui_context: 'Card Builder',
    }
    const v2 = result.imageCheckerV2
    if (v2?.outcome) {
        return {
            checker: 'v2',
            check_id: v2.check_id ?? null,
            rule_ids: v2.rule_ids ?? [],
            top_confidence: v2.top_confidence ?? null,
            ...shared,
        }
    }

    return {
        checker: 'legacy',
        check_id: null,
        rule_ids: [],
        top_confidence: null,
        ...shared,
    }
}

export function trackAiImageCheckResult(result, options) {
    try {
        const properties = aiImageCheckResultProperties(result, options)
        if (properties) {
            fullstoryEvent(AI_IMAGE_CHECK_RESULT, properties)
        }
    } catch (e) {
        // Measurement must never affect the upload flow.
    }
}
